import React from 'react'
import { BramkaTresci } from './BramkaLogowania'

/**
 * Bramka dla ścieżek partnerskich: zgłoszenie wysyła się z konta, nie anonimowo.
 *
 * ═══ DLACZEGO PODGLĄD, A NIE PRZEKIEROWANIE ═══
 * Najprościej byłoby odesłać niezalogowanego na `/logowanie`. Kosztowałoby to
 * jednak dokładnie tych, po których ta strona istnieje: firma klika „Zostań
 * partnerem", ląduje na formularzu logowania i nie wie, czy to, co jest dalej,
 * jest warte zakładania konta. Rozmyty podgląd odpowiada na to bez słów —
 * widać, że po drugiej stronie są konkretne pytania, a nie pusta obietnica.
 *
 * Cała mechanika (rozmycie, `inert`, karta z zachętą) siedzi w `BramkaTresci`,
 * wspólnej dla wszystkich treści za logowaniem. Ten plik zostaje osobno, bo
 * niesie WŁASNĄ treść komunikatu i jest podpięty w routingu (App.js) — a nie
 * dlatego, że działa inaczej.
 *
 * Podgląd jest PRZYCIĘTY do jednego ekranu — pełna, rozmyta strona to kilka
 * tysięcy pikseli treści, przez którą nie da się przewinąć do niczego sensownego.
 */

const BramkaPartnera = ({ children }) => (
  <BramkaTresci
    maxWysokosc="max-h-[70vh]"
    tytul="Dostęp tylko dla zalogowanych"
    opis="Zgłoszenie przypisujemy do konta, dzięki temu możesz je później
          uzupełnić i śledzić, na jakim jest etapie. Rejestracja jest bezpłatna."
  >
    {children}
  </BramkaTresci>
)

export default BramkaPartnera
